export const FUNCTIONS_URL = process.env.REACT_APP_FUNCTIONS_URL || '';
export const API_URL = process.env.REACT_APP_API_URL || '';
export const GRAPHQL_URL = process.env.REACT_APP_GRAPHQL_URL || '';
export const MEDIA_URL = process.env.REACT_APP_MEDIA_URL || '';
